// extracted by mini-css-extract-plugin
export default {"container":"Paths_container__0YbX+","search":"Paths_search__GC-FG","wrapper":"Paths_wrapper__K13dI"};